import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

import { H2, H3 } from "./headings";
import { S3_BUCKET } from "../constants";
import { currencyNeedsSpace, getFirstLetter } from "../helpers";
import { P, MuiAvatar, ProgressBar } from ".";
import { donationConstants } from "../store/actionTypes";
import { useMediaQuery } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import DefaultCover from "../assets/images/cover.jpg"

export function DonationImpactCard({ pageDetails, assignClasses, isFundraiserPage }) {

    const [donationEffect, setDonationEffect] = useState(0);
    const [donationRaisedPercentage, setDonationRaisedPercentage] = useState(0);
    const isDesktop = useMediaQuery('(min-width:992px)');
    let avatarName, cardTitle, pageCreatedBy;
    const donationImpact = useSelector(state => state.donation.product_impact)
    const donationAmount = useSelector(state => state.donationCheckout.donationAmount);
    const selectedCountry = useSelector(state => state.donationCheckout.selectedCountry.id);
    const selectedCurrency = useSelector(state => state.donationCheckout.selectedCountry.currency.symbol);
    const formattedCurrency = selectedCurrency + (currencyNeedsSpace(selectedCurrency) ? " " : "");
    const currencyConversionRate = useSelector(state => state.donationCheckout.currencyConversionRate);
    const totalDonations = pageDetails.count_donations;
    const currencySymbol = pageDetails.symbol_left
    const donationText = totalDonations > 1 ? 'donations' : 'donation';
    const impactDescription = useMemo(
        () => {
            return donationImpact?.product_impact > 1 ?
                <>lives of <b>{donationImpact.product_impact}</b> students</>
                : <>life of <b>1</b> student</>
        },
        [pageDetails, donationImpact.product_impact]
    );

    if (isFundraiserPage) {
        avatarName = getFirstLetter(pageDetails.first_name) + ' ' + getFirstLetter(pageDetails.last_name);
        cardTitle = pageDetails.page_title;
        pageCreatedBy = pageDetails.first_name + ' ' + pageDetails.last_name;
    }
    else {
        avatarName = getFirstLetter(pageDetails.name);
        cardTitle = pageDetails.name;
        pageCreatedBy = 'The Citizens Foundation';
    }

        const mapGoalDescription = useCallback(() => {
		let contentforeRaised, contentForGoal, amount, goalContent;
		if (isFundraiserPage || !pageDetails.campaign_goal) {
			contentforeRaised = isFundraiserPage
				? pageDetails.symbol_left +
				  (currencyNeedsSpace(pageDetails.symbol_left) ? " " : "") +
				  (donationConstants.AMOUNT_FORMAT.includes(pageDetails.code)
						? pageDetails.total_fund_raised.toLocaleString('de-DE')
						: pageDetails.total_fund_raised.toLocaleString())
				: pageDetails.total_fund_raised.toLocaleString();

			contentForGoal = `raised of`;
            amount = (
                <>
                    {currencySymbol}{currencyNeedsSpace(currencySymbol) ? " " : ""}
                    {donationConstants.AMOUNT_FORMAT.includes(pageDetails.code)
                    ? pageDetails.total_fund_goal_millions.toLocaleString('de-DE')
                    : pageDetails.total_fund_goal_millions.toLocaleString()
                    }
                </>
            );
			goalContent = (
				<>
					from <b>{totalDonations}</b> {donationText}
				</>
			);
		} else {
			contentforeRaised =
				'Supporting' +
				' ' +
				(donationConstants.AMOUNT_FORMAT.includes(pageDetails.code)
					? pageDetails.total_fund_raised.toLocaleString('de-DE')
					: pageDetails.total_fund_raised.toLocaleString());
			amount = donationConstants.AMOUNT_FORMAT.includes(pageDetails.code)
				? pageDetails.fundraising_goal.toLocaleString('de-DE')
				: pageDetails.fundraising_goal.toLocaleString();
			contentForGoal = 'out of';
			goalContent = 'students';
		}


		return (
			<div className="goalamount">
				<H2 content={contentforeRaised} />
				<P>
					{contentForGoal + ' '}
					{amount}{" "}
					{goalContent}
				</P>
			</div>
		);
	}, [pageDetails]);

    useEffect(() => {
        const totalFundsRaised = isFundraiserPage ? pageDetails.total_fund_raised : pageDetails.int_total_fund_raised;
        const fundraisingGoal = isFundraiserPage ? pageDetails.fundraising_goal : pageDetails.int_fundraising_goal;

        let raisedPercentage = (totalFundsRaised / fundraisingGoal) * 100;
        raisedPercentage = Math.round(raisedPercentage);

        if (raisedPercentage > 100)
            raisedPercentage = 100

        setDonationRaisedPercentage(raisedPercentage);
    }, [])

    useEffect(() => {
        let donationEffect = 0;
        if (donationAmount > 0 && (isFundraiserPage || !pageDetails.campaign_goal)) {

            const totalFundsRaised = isFundraiserPage ? pageDetails.total_fund_raised : pageDetails.int_total_fund_raised;
            const fundraisingGoal = isFundraiserPage ? pageDetails.fundraising_goal : pageDetails.int_fundraising_goal;

            pageDetails.currency_id === selectedCountry ?
                donationEffect = ((parseFloat(totalFundsRaised) + parseFloat(donationAmount)) / parseFloat(fundraisingGoal)) * 100
                :
                donationEffect = ((parseFloat(totalFundsRaised) + parseFloat((parseFloat(donationAmount)) * (parseFloat(currencyConversionRate)) / (parseFloat(pageDetails.value)))) / (parseFloat(fundraisingGoal))) * 100;

            if (donationEffect > 100)
                donationEffect = 100;

            donationEffect = Math.round(donationEffect - donationRaisedPercentage);

            setDonationEffect(donationEffect);
        }
        else setDonationEffect(0)
    }, [donationAmount])

    useEffect(() => {
        let donationEffect = 0;
        if (donationImpact.product_impact > 0 && !isFundraiserPage && pageDetails.campaign_goal) {
            donationEffect = (donationImpact.product_impact + pageDetails.int_total_fund_raised) / pageDetails.int_fundraising_goal
            donationEffect = donationEffect * 100;
            if (donationEffect > 100) {
                donationEffect = 100;
            }
            donationEffect = Math.round(donationEffect - donationRaisedPercentage);
            setDonationEffect(donationEffect)
        }
        // else setDonationEffect(0)
    }, [donationImpact.product_impact])

    return <div className={assignClasses}>
        <div className="donategoal">
            <div className="imgarea">
                <LazyLoadImage
                    className="imgpart"
                    src={S3_BUCKET + (pageDetails.cover_image ?? pageDetails.campaign_image)}
                    fullName={pageCreatedBy}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = DefaultCover;
                    }}
                />
                <div className="right">
                    <P>You're supporting</P>
                    <div title={cardTitle}>
                        <H2 content={cardTitle} />
                    </div>
                    <P>by {pageCreatedBy}</P>
                </div>
            </div>
            {pageDetails.fundraising_goal &&
                <>
                    {mapGoalDescription()}
                    <div className="scrollrange">
                        {/* Scroll Range */}
                        <ProgressBar percentage={donationRaisedPercentage} donationEffectPercentage={donationEffect} />
                    </div>
                </>
            }
            {pageDetails.show_impact_message == 1 &&
                <div className="impact-txt">
                    <H3 content={isDesktop ? `Your Impact` : `Amount: ${formattedCurrency}${donationAmount?? 0}`} />
                    {!pageDetails.is_special ? (donationImpact.product_impact > 0
                        ?
                        <P>
                            You are going to impact the {impactDescription}
                        </P>
                        :
                        <P>Your donation will support the general education fund</P>
                    ) :
                        'Your donation supports the flood relief affectees in Pakistan'
                    }
                </div>}
        </div>
    </div>
}